<app-page-layout [isSubscription]="true">
    <ng-container *ngIf="isLoading();else display">
        <app-loading></app-loading>
    </ng-container>
    <ng-template #display>
        <div class="row">
            <div class="titre">
                <b>
                    <h3>{{('REGISTRATION.TITLE' ) | translate}}</h3>
                </b>
            </div>
            <div class="main-frame">
                <mat-horizontal-stepper [linear]="isLinear" [selectedIndex]="registerState.currentSection" #stepper>
                    <mat-step [completed]="registerState.sectionCompleted[0]" [editable]="isEditable">
                        <ng-template matStepLabel>{{'REGISTRATION.STEP.NETWORK_CHECK.TITLE' | translate}}</ng-template>
                        <app-network-check [coverage]="subscriptionBundle.coverage"
                            [options]="subscriptionBundle.options" (coverageEmitter)="updateCoverage($event)"
                            (optionEmitter)="updateOptions($event)" (currentSection)="nextPageFrom($event)">
                        </app-network-check>
                    </mat-step>
                    <mat-step [completed]="registerState.sectionCompleted[1]" [editable]="isEditable">
                        <ng-template matStepLabel>{{'REGISTRATION.STEP.PERSONALIZE.TITLE' | translate}}</ng-template>
                        <ng-container *ngIf="registerState.sectionCompleted[0]">
                            <app-personalize [itemConfig]="subscriptionBundle.itemConfig"
                                (watchEmitter)="updateItemConfig($event)" (currentSection)="nextPageFrom($event)"
                                [options]="subscriptionBundle.options" (optionEmitter)="updateOptions($event)">
                            </app-personalize>
                        </ng-container>
                    </mat-step>
                    <mat-step [completed]="registerState.sectionCompleted[2]" [editable]="isEditable">
                        <ng-template matStepLabel>{{'REGISTRATION.STEP.ACCOUNT_CREATION.TITLE' | translate}}
                        </ng-template>
                        <ng-container *ngIf="registerState.sectionCompleted[1]">
                            <app-account-creation [itemConfig]="subscriptionBundle.itemConfig"
                                [recipientInformation]="subscriptionBundle.recipientInformation"
                                [coverage]="subscriptionBundle.coverage" [helper]="subscriptionBundle.helper"
                                [helped]="subscriptionBundle.helped" (helperEmitter)="updateHelper($event)"
                                (helpedEmitter)="updateHelped($event)" (recipientEmitter)="updateRecipientInfo($event)"
                                (currentSection)="nextPageFrom($event)"></app-account-creation>
                        </ng-container>
                    </mat-step>
                    <mat-step [completed]="registerState.sectionCompleted[3]" [editable]="isEditable">
                        <ng-template matStepLabel>{{'REGISTRATION.STEP.PAYMENT.TITLE' | translate}}</ng-template>
                        <ng-container *ngIf="registerState.sectionCompleted[2]">
                            <app-payment [subscriptionBundle]="subscriptionBundle"
                                [itemConfig]="subscriptionBundle.itemConfig" [options]="subscriptionBundle.options"
                                (currentSection)="nextPageFrom($event)" (discountEmitter)="updateDiscount($event)"
                                (paymentEmitter)="updatePaymentData($event)"
                                (subscriptionEmitter)="updateSubscription($event)"
                                (taxCreditEmitter)="updateTaxCreditForSubscription($event)"
                                (additionalInfoEmitter)="updateAdditionalInfo($event)"
                                (optionEmitter)="updateOptions($event)"></app-payment>
                        </ng-container>
                    </mat-step>

                    <!-- Icon overrides -->
                    <ng-template matStepperIcon="edit">
                        <mat-icon>done</mat-icon>
                    </ng-template>
                </mat-horizontal-stepper>
                <div class="center conditions">
                    <a href="https://www.co-assist.fr/mentions-legales/" target="_blank"
                        rel="noopener noreferrer">{{'REGISTRATION.LEGAL_INFO'|translate}}</a>
                </div>
            </div>
        </div>
    </ng-template>
</app-page-layout>